import { BaseFieldWidget, ModelFieldType, ViewType, SPI, FormStringUploadFieldWidget } from '@kunlun/dependencies';
import CustomUploadImage from './CustomUploadImage.vue';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Detail],
    ttype: ModelFieldType.String,
    widget: ['CustomUploadImage']
  })
)
export class DetailStringUploadImgFieldWdiget extends FormStringUploadFieldWidget {
  public initialize(config) {
    super.initialize(config);
    this.setComponent(CustomUploadImage);
    return this;
  }
}
